/**
 * @function event.registerAuthenticationEvents
 * @param {Vuex} store
 */
export default function registerAuthenticationEvents(store){
  store.subscribe(({ type, payload }, state) => {
    if (type === 'setLoggedIn' && payload === false){
      alert('logged out!');
    }
  })
}